import { ComponentType, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiCommission, ApiSpecialities } from 'src/http';
import { Commission } from '../commissions';
import { Page } from '../page';
import BasicTable from './BasicTable';

export interface Speciality extends Commission {
  commission: string;
}

export const Specialities: ComponentType = () => {
  const [data, setData] = useState<Speciality[] | null>(null);
  const [total, setTotal] = useState<number>(0);
  const getSpecialities = async (page?: string) => {
    let params = {
      skip: page && Number(page) > 0 ? (Number(page) - 1) * 10 : 0,
      take: 10,
    };
    try {
      const data = await ApiSpecialities.fetchAll(params);
      setData(data.hits);
      setTotal(Math.ceil(data.total / 10));
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  const [commissions, setCommissions] = useState<Commission[] | null>(null);
  const getCommissions = async () => {
    let params = {
      skip: 0,
      take: 100,
    };
    try {
      const data = await ApiCommission.fetchAll(params);
      setCommissions(data.hits);
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  const createItem = async (item: Speciality) => {
    try {
      await ApiSpecialities.createOne(item);
      setData(null);
      getSpecialities();
    } catch ({ message }: any) {
      console.log(message);
    }
  };
  const updateItem = async (item: Speciality) => {
    try {
      await ApiSpecialities.updateOne(item.id || 0, item);
      setData(null);
      getSpecialities();
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  const changePagination = (page: string) => {
    getSpecialities(page);
  };

  useEffect(() => {
    getSpecialities();
    getCommissions();
  }, []);

  const { t } = useTranslation();
  return (
    <Page title={t('specialties', 'Список специальностей')}>
      {data ? (
        <BasicTable
          data={data}
          createItem={createItem}
          updateItem={updateItem}
          commissions={commissions}
          changePagination={changePagination}
          total={total}
        />
      ) : null}
    </Page>
  );
};
